import { style } from '@vanilla-extract/css'

const heading = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '19px',
  lineHeight: '1.5',
  textWrap: 'pretty',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  wordBreak: 'keep-all',
})


const text = style({
  fontSize: '15px',
  lineHeight: '1.5',
})

const card = style({
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  borderRadius: '16px',
  padding: '16px',
})

const introduction = style({
  fontFamily: 'Noto Sans JP Variable, sans-serif',
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const button = style({
  maxWidth: '327px',
})

export const styles = {
  heading,
  text,
  card,
  introduction,
  button,
}
